import React from 'react';
import styled from 'styled-components';
import { minBp } from 'src/lib/theme';

export const Outer = styled.div`
  display: flex;
  height: 61px;
  margin: 8px 0;

  .rc-slider {
    position: relative;
    height: 2px;
    width: 100%;
    border-radius: 0;
    -ms-touch-action: none;
    touch-action: none;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    top: 12px;
    border-left: 4px solid #bfbfbf;
    border-right: 4px solid #bfbfbf;

    @media ${minBp('tabletLarge')} {
      border-left: 4px solid #515151;
      border-right: 4px solid #515151;
    }
  }

  .rc-slider-rail {
    position: absolute;
    width: 100%;
    background-color: #bfbfbf;
    height: 2px;
    border-radius: 0px;

    @media ${minBp('tabletLarge')} {
      background-color: #515151;
    }
  }

  .rc-slider-track {
    position: absolute;
    left: 0;
    height: 2px;
    border-radius: 0px;
    background-color: #000;

    @media ${minBp('tabletLarge')} {
      background-color: #fff;
    }
  }

  .rc-slider-step {
    position: absolute;
    width: 100%;
    height: 4px;
    background: transparent;
  }

  .rc-slider-dot {
    position: absolute;
    bottom: -2px;
    margin-left: -4px;
    width: 8px;
    height: 8px;
    border: 2px solid #e9e9e9;
    background-color: #fff;
    cursor: pointer;
    border-radius: 50%;
    vertical-align: middle;
    display: none;

    &-active {
      border-color: #96dbfa;
    }
  }

  .rc-slider-handle {
    position: absolute;
    width: 8px;
    height: 8px;
    cursor: pointer;
    cursor: -webkit-grab;
    margin-top: -3px;
    cursor: grab;
    border-radius: 50%;
    border: 0;
    background-color: #000;
    -ms-touch-action: pan-x;
    touch-action: pan-x;

    @media ${minBp('tabletLarge')} {
      background-color: #fff;
    }
  }

  .rc-slider-mark {
    position: absolute;
    top: 18px;
    left: 0;
    width: 100%;
    font-size: 12px;
  }

  .rc-slider-mark-text {
    position: absolute;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    cursor: pointer;
    color: #999;
    display: none;

    &-active {
      color: #666;
    }
  }
`;

export const Circle = styled.button`
  appearance: none;
  background-color: transparent;
  width: 26px;
  height: 26px;
  min-width: 26px;
  min-height: 26px;
  max-width: 26px;
  max-height: 26px;
  border-radius: 50%;
  border: 2px solid #000;
  position: relative;
  cursor: pointer;
  padding: 0;

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 18px;
    height: 18px;

    path {
      fill: #000;
    }
  }

  @media ${minBp('tabletLarge')} {
    border: 2px solid white;

    svg {
      path {
        fill: white;
      }
    }
  }
`;

export const HandleWrap = styled.div`
  ${({ left = 0 }) => `
    left: ${left}%;
    right: auto;
    position: relative;
  `}
`;

export const Handle = styled.div`
  position: absolute;
  width: 8px;
  height: 8px;
  cursor: pointer;
  cursor: -webkit-grab;
  margin-top: -3px;
  cursor: grab;
  border-radius: 50%;
  border: 0;
  background-color: #fff;
  -ms-touch-action: pan-x;
  touch-action: pan-x;
  transform: translateX(-50%);
`;

export const Tooltip = styled.div`
  width: 40px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.dinDemi};
  font-size: 12px;
  position: absolute;
  left: 0;
  transform: translateX(-50%);
  top: 26px;
  background-color: #000;
  border-radius: 4px;
  cursor: pointer;
  cursor: -webkit-grab;
  color: white;

  &:after {
    content: ' ';
    position: absolute;
    top: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 6px 6px 6px;
    border-color: transparent transparent #000 transparent;
  }

  @media ${minBp('tabletLarge')} {
    background-color: white;
    color: #000;

    &:after {
      border-color: transparent transparent white transparent;
    }
  }
`;
